var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ueditor-wrap',{attrs:{"config":_vm.editorConfig,"editor-id":"editor-demo-01"},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}}),_c('div',{on:{"click":_vm.getUE}},[_vm._v("获取富文本内容")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }